import React, {useState} from "react";
import './style.scss'
import Popup from "../../components/core/Popup";
import {validateMail} from "../../utils";
import InputMask from "react-input-mask";
import {useFieldArray, useForm} from "react-hook-form";
import useMedia from "../../hooks/useMedia";
import tgqr from './tgqr.png'
import PersonalCabinet from "../PersonalCabinet";


const phoneRequired = (v) =>
  v && v.indexOf("_") === -1 ? undefined : "Введите телефон";
const Input = (props) => {
  const { name, inputRef, value, ...rest } = props;
  return (
    <InputMask {...rest} mask="+7 (999) 999-99-99" maskChar="_">
      {(inputProps) => (
        <input value={value} name={name} ref={inputRef} {...inputProps} />
      )}
    </InputMask>
  );
};

const PersonalProfile = () => {

  const defaultValues = {
    "id": "681",
    "name": "Роман",
    "lastName": "Мичкодан",
    "patronymic": "Владимирович",
    "phone": [
      "+7 (960) 260-93-13"
    ],
    "email": [
      "michkodan@1-an.ru"
    ],
    "telegram": "@RomanMichkodan",
    "watsApp": "+7 (960) 260-93-13",
    "workLogo": {
      "id": 534974,
      "src": "/upload/main/b1d/aj3wpp0z65ef068i37vt49b0tano2ohz/pan.png",
      "contentType": "image/png",
      "width": 128,
      "height": 128,
      "description": "",
      "fileSize": 3108
    },
    "workCompany": "Первое Агентство НедвижимостиXXX",
    "cityName": "Санкт-Петербург"
  }
  const [validValue, setValidValue] = useState("")
  const telegramInputFocus = (e) => {
    if (e.target.value) {
      return
    }
    setValidValue("@")
    setValue(`telegram`, "@")
  }
  const telegramBlur = (e)=> {
    if (e.target.value === "@") {
      setValidValue("")
      setValue(`telegram`, "")
    }
  }
  const setTelegramValue = (e) => {
    let val = e.currentTarget.value
    if(val && val[0] !== "@"){
      setValue(`telegram`, `@${val}`)
      val = `@${val}`
    }
    let match = val.match(/^@[_0-9a-zA-Z]{0,}/)
    if (match && match[0] === val) {
      setValidValue(val)
      setValue(`telegram`, val)
    } else {
      setValue(`telegram`, validValue)
    }
  }
  const isMobile = useMedia("isMobile");
  const { handleSubmit, register, errors, control, setValue} = useForm({
    defaultValues,
  });
  const { fields, append, remove } = useFieldArray({
    control,
    name: "phone",
  });
  const {
    fields: fieldsEmail,
    append: appendEmail,
    remove: removeEmail,
  } = useFieldArray({
    control,
    name: "email",
  });


  const [tgFix, setTgFix] = useState(true)
  const [tgDeal, setTgDeal] = useState(true)
  const [tgSF, setTgSf] = useState(true)

  return (
    <>
      <PersonalCabinet />
      <div className="wrapper cabinet-profile">
      <div className="cabinet-profile__header">
        <p className="cabinet-profile__header-title">Личный профиль</p>
        <div className="cabinet-profile__user">
          <div className="cabinet-profile__user-logo">
            <img src="https://crm.panpartner.ru/upload/main/adc/0X8A6278.png" alt=""/>
          </div>
          <div className="cabinet-profile__user-name">
            <span>Овсянов Овсян Овсянович</span>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.95923 20.0012H4.70846C4.52057 20.0012 4.34037 19.9265 4.2075 19.7937C4.07464 19.6608 4 19.4806 4 19.2927V15.3336C4.00015 15.1481 4.07307 14.97 4.20309 14.8377L14.83 4.21076C14.9619 4.07714 15.1414 4.00135 15.3292 4.00002C15.5169 3.99869 15.6975 4.07194 15.8313 4.20367L15.8384 4.21076L19.7881 8.16043C19.8545 8.22568 19.9074 8.30338 19.9437 8.3891C19.9801 8.47481 19.9992 8.56685 20 8.65995C20.0007 8.75306 19.9832 8.8454 19.9482 8.9317C19.9133 9.018 19.8616 9.09656 19.7963 9.1629L19.7881 9.16999L8.95923 20.0012Z" stroke="#8790E5" stroke-linecap="round" stroke-linejoin="round"/><path d="M12.5015 6.53906L17.4607 11.4983" stroke="#8790E5" stroke-linecap="round" stroke-linejoin="round"/><path d="M19.5862 19.9998H8.95928L4.04492 15.0854" stroke="#8790E5" stroke-linecap="round" stroke-linejoin="round"/><path d="M14.981 9.01904L6.47949 17.5206" stroke="#8790E5" stroke-linecap="round" stroke-linejoin="round"/></svg>
          </div>
        </div>
      </div>

      <div className="lk-form__row for-contacts">
        <div className="lk-form__row-content">
          <div className="lk-form__fr">
            {fields.map((item, index) => (
              <label
                className="input input_type_form input_width_available"
                htmlFor={`cl-phone${index}`}
                key={`phone${index}`}
              >
                <span className="input__label">Телефон:</span>

                <Input
                  name={`phone[${index}]`}
                  className={
                    "input__control" +
                    (errors.phone && errors.phone[index]
                      ? " input__error"
                      : "")
                  }
                  type="text"
                  id={`cl-phone${item.id}`}
                  inputRef={register({
                    required: "Введите телефон",
                    validate: { inputTelRequired: phoneRequired },
                  })}
                  defaultValue={item.value}
                  key={item.id}
                  mask="+7 (999) 999-99-99"
                />

                {index === 0 ? (
                  <span className="input__alert info">
                              {isMobile ?
                                <Popup
                                  trigger={
                                    <svg className="icon icon_alert">
                                      <use xlinkHref="#alert"></use>
                                    </svg>
                                  }
                                >
                                  <p>
                                    <strong>Приоритетный номер</strong>
                                  </p>
                                  <br />
                                  <p style={{ lineHeight: '18px '}}>
                                    При заполненни формы обратной связи, этот
                                    номер будет автоматически подставляться в
                                    форму.
                                  </p>
                                </Popup> :
                                <svg className="icon icon_alert">
                                  <use xlinkHref="#alert"></use>
                                </svg>
                              }
                    {!isMobile &&
                      <div className="info__popup">
                        <p>
                          <strong>Приоритетный номер</strong>
                        </p>
                        <p>
                          При заполненни формы обратной связи, этот
                          номер будет автоматически подставляться в
                          форму.
                        </p>
                      </div>
                    }
                            </span>
                ) : (
                  <button
                    className="input__remove"
                    onClick={(e) => {
                      remove(index);
                      e.preventDefault();
                    }}
                  >
                    <svg
                      className="icon"
                      width="7"
                      height="8"
                      viewBox="0 0 7 8"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M5.66667 1.3L0.333333 6.7"
                        strokeLinecap="round"
                      ></path>
                      <path
                        d="M0.333333 1.3L5.66667 6.7"
                        strokeLinecap="round"
                      ></path>
                    </svg>
                  </button>
                )}
              </label>
            ))}
            <div className="lk-form__add-param">
              <button
                className="button button_type_add"
                onClick={(e) => {
                  e.preventDefault();
                  append("");
                }}
              ></button>
              <span>Добавить ещё телефон</span>
            </div>
          </div>
          <div className="lk-form__fr">
            {fieldsEmail.map((item, index) => (
              <label
                className="input input_type_form input_width_available"
                htmlFor={`cl-email${index}`}
                key={index}
              >
                <span className="input__label">E-mail:</span>
                <input
                  name={`email[${index}]`}
                  className={
                    "input__control" +
                    (errors.email && errors.email[index]
                      ? " input__error"
                      : "")
                  }
                  type="email"
                  id={`cl-email${index}`}
                  autoComplete="off"
                  ref={register({
                    required: "Введите e-mail",
                    pattern: {
                      value: validateMail,
                      message: "Неправильный формат e-mail",
                    },
                  })}
                />
                {index === 0 ? (
                  <span className="input__alert info">
                              {isMobile ?
                                <Popup
                                  trigger={
                                    <svg className="icon icon_alert">
                                      <use xlinkHref="#alert"></use>
                                    </svg>
                                  }
                                >
                                  <p>
                                    <strong>Приоритетный e-mail</strong>
                                  </p>
                                  <br />
                                  <p style={{ lineHeight: '18px '}}>
                                    При заполненни формы обратной связи, этот
                                    e-mail будет автоматически подставляться в
                                    форму.
                                  </p>
                                </Popup> :
                                <svg className="icon icon_alert">
                                  <use xlinkHref="#alert"></use>
                                </svg>
                              }
                    {!isMobile &&
                      <div className="info__popup">
                        <p>
                          <strong>Приоритетный e-mail</strong>
                        </p>
                        <p>
                          При заполненни формы обратной связи, этот
                          e-mail будет автоматически подставляться в
                          форму.
                        </p>
                      </div>
                    }
                            </span>
                ) : (
                  <button
                    className="input__remove"
                    onClick={(e) => {
                      removeEmail(index);
                      e.preventDefault();
                    }}
                  >
                    <svg
                      className="icon"
                      width="7"
                      height="8"
                      viewBox="0 0 7 8"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M5.66667 1.3L0.333333 6.7"
                        strokeLinecap="round"
                      ></path>
                      <path
                        d="M0.333333 1.3L5.66667 6.7"
                        strokeLinecap="round"
                      ></path>
                    </svg>
                  </button>
                )}
              </label>
            ))}
            <div className="lk-form__add-param">
              <button
                className="button button_type_add"
                onClick={(e) => {
                  e.preventDefault();
                  appendEmail("");
                }}
              ></button>
              <span>Добавить ещё e-mail</span>
            </div>
          </div>
          <div className="lk-form__socials">
            <div className="lk-form__fr">
              <label
                className="input input_type_form input_type_form_icon-left input_width_available"
                htmlFor="lk-form-whatsapp"
              >
                <span className="input__label">What's app:</span>
                <InputMask
                  name={`watsApp`}
                  id="lk-form-whatsapp"
                  className={"input__control"}
                  defaultValue={defaultValues.watsApp}
                  inputRef={register({})}
                  mask="+7 (999) 999-99-99"
                ></InputMask>
                <span className="input__icon">
                            <svg className="icon icon_watch">
                              <use xlinkHref="#socials_whatsapp"></use>
                            </svg>
                          </span>
              </label>
            </div>
            <div className="lk-form__fr">
              <label
                className="input input_type_form input_type_form_icon-left input_width_available"
                htmlFor="lk-form-tg"
              >
                <span className="input__label">Telegram:</span>
                <input
                  name={`telegram`}
                  id="lk-form-tg"
                  className={
                    "input__control" +
                    (errors.telegram ? " input__error" : "")
                  }
                  defaultValue={defaultValues.telegram}
                  ref={register({
                    pattern: /@[_0-9a-zA-Z]{5,}/
                  })}

                  onFocus={telegramInputFocus}
                  onChange={e => setTelegramValue(e)}
                  onBlur={e => telegramBlur(e)}
                ></input>
                <span className="input__icon">
                            <svg className="icon icon_watch">
                              <use xlinkHref="#socials_tg"></use>
                            </svg>
                          </span>
              </label>
            </div>
          </div>
        </div>
      </div>

      <div className="cabinet-profile__area">
        <textarea
          className="cabinet-textarea"
          placeholder="По желанию Вы можете указать информацию о пользователе"
        ></textarea>

        <div className="cabinet-profile__tghint">
          <p><b>Настроить оповещения в Телеграм</b></p>
          <p>Чтобы получать уведомления — добавьте бота в личный чат или группу в Telegram. </p>
          <p>Гибко настраивайте свои уведомления.</p>
        </div>
        <div className="cabinet-profile__tgtoogle">
          <div className="cabinet-profile__tgtoogle-left">
            <p><b>Уведомления в телеграм:</b></p>
            <div>
              <label className="switch" htmlFor="buildingSettings">
              <span className="switch__label">
                Статусы фиксации, записи на просмотр
              </span>
                <div className="switch__box">
                  <input
                    className="switch__control"
                    type="checkbox"
                    id="buildingSettings"
                    onChange={() => {
                      setTgFix(!tgFix)
                    }}
                    checked={tgFix}
                  />
                  <div className="switch__input" htmlFor="buildingSettings"/>
                  <div className="switch__marker"/>
                </div>
              </label>
            </div>
            <div>
              <label className="switch" htmlFor="buildingSettings">
              <span className="switch__label">
                Статусы сделок
              </span>
                <div className="switch__box">
                  <input
                    className="switch__control"
                    type="checkbox"
                    id="buildingSettings"
                    onChange={() => {
                      setTgDeal(!tgDeal)
                    }}
                    checked={tgDeal}
                  />
                  <div className="switch__input" htmlFor="buildingSettings"/>
                  <div className="switch__marker"/>
                </div>
              </label>
            </div>
            <div>
              <label className="switch" htmlFor="buildingSettings">
              <span className="switch__label">
                Открытие клиентом презентаций, СФ, сравнений
              </span>
                <div className="switch__box">
                  <input
                    className="switch__control"
                    type="checkbox"
                    id="buildingSettings"
                    onChange={() => {
                      setTgSf(!tgSF)
                    }}
                    checked={tgSF}
                  />
                  <div className="switch__input" htmlFor="buildingSettings"/>
                  <div className="switch__marker"/>
                </div>
              </label>
            </div>
          </div>
          <div className="cabinet-profile__tgtoogle-right">
            <img src={tgqr} alt=""/>
          </div>
        </div>
      </div>




    </div>
    </>
  )
}

export default PersonalProfile
